import { addRolesToTenantUser, createTenantMachineClient, deleteTenantUser } from '@infuse/api/iam/tenant';
import { useGenericCreateMachineUser } from '@infuse/iam/user/mutations';

export const useCreateTenantMachineUser = () =>
  useGenericCreateMachineUser({
    apiFn: createTenantMachineClient,
    roleApiFn: addRolesToTenantUser,
    deleteApiFn: deleteTenantUser
  });
